module.exports = __webpack_public_path__ + "img/04.11d56331.png";